import { Outlet, Navigate } from "react-router-dom";
import NavBar from "../Navbar/AdminNavBar";

const AdminRoutes = () => {
  let role = localStorage.getItem("Role");
  if (role === "Shipper") {
    return <Navigate to="/" />;
  } else if (role === "Carrier") {
    return <Navigate to="/create-zone" />;
  } else if (role === "Admin") {
    return (
      <>
        <NavBar />
        <Outlet />
      </>
    );
  } else if (role === "warehouseUser") {
    return <Navigate to="/warehouse-orders" />;
  } else {
    return <Navigate to="/Login" />;
  }
};

export default AdminRoutes;
